<template>
  <div>
    <h3 class="text-static-default-hi heading-1">
      {{ i18n(translations.title) }}
    </h3>
    <div class="text-static-default-low body-2">
      {{ i18n(translations.subtitle) }}
    </div>

    <div class="mb-8 mt-20 space-y-12">
      <RevInputText
        id="recipientName"
        v-model="recipientName"
        :error="recipientNameError"
        :label="i18n(translations.recipientInputLabel)"
      />
      <RevInputText
        id="senderName"
        v-model="senderName"
        :error="senderNameError"
        :label="i18n(translations.senderInputLabel)"
      />
      <RevInputTextarea
        id="message"
        v-model="message"
        :error="messageError"
        :label="i18n(translations.messageInputLabel)"
        :rows="3"
      />
    </div>
    <div v-if="!messageError">
      {{
        i18n(translations.messageInputLabelInfo, {
          characterLimit: characterLimit,
        })
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputText } from '@ds/components/InputText'
import { RevInputTextarea } from '@ds/components/InputTextarea'

import translations from './GiftCardMessage.translations'

const i18n = useI18n()

const recipientName = defineModel('recipientName', { type: String })
const senderName = defineModel('senderName', { type: String })
const message = defineModel('message', { type: String })

defineProps<{
  characterLimit: number
  recipientNameError: string | undefined
  senderNameError: string | undefined
  messageError: string | undefined
}>()
</script>
